import React from "react";

interface StatProps {
  /** The numeral itself, e.g. "4,300" or "12×" or "98%". */
  value: string;
  /** Caption rendered in Inter beneath the numeral. */
  caption: React.ReactNode;
  /** Optional footnote marker, e.g. "1" → renders ¹ as a superscript anchor. */
  footnote?: string | number;
  /** Bigger size, used as a hero anchor. */
  size?: "xl" | "lg";
  className?: string;
}

export function Stat({ value, caption, footnote, size = "lg", className = "" }: StatProps) {
  const valueClass =
    size === "xl"
      ? "text-6xl sm:text-7xl lg:text-stat-xl"
      : "text-5xl sm:text-6xl lg:text-stat";

  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      <span className={`font-display ${valueClass} text-coffee-900 dark:text-cream-50 tracking-tight tabular-nums`}>
        {value}
        {footnote !== undefined && (
          <a
            href={`#fn-${footnote}`}
            className="ml-1 align-super text-base font-mono text-accent-500 no-underline hover:text-accent-700"
            aria-describedby={`fn-${footnote}`}
          >
            {footnote}
          </a>
        )}
      </span>
      <span className="text-body-sm text-coffee-700 dark:text-cream-200 max-w-[24ch]">
        {caption}
      </span>
    </div>
  );
}

export default Stat;
